import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const items = ['Libro digital: Comunicación Magnética', 'Plantillas copiables para reuniones, videollamadas y mensajes', 'Ejercicios breves para convertir esto en hábito', 'Hojas de trabajo prácticas'];
export function WhatsIncluded() {
  return <section className="py-24 bg-black text-white" data-id="element-472">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-473">
        <div className="text-center mb-16" data-id="element-474">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-6xl font-bold mb-4" data-id="element-475">
            Qué incluye
          </motion.h2>
        </div>

        {/* Image 4 - What's Included - Exact replica of the design */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-6xl mx-auto rounded-3xl overflow-hidden shadow-2xl border border-[#C9A961]/20" data-id="element-476">
          <img src="https://cdn.magicpatterns.com/uploads/ehGK428Zv8jkrDhVDDgChH/4-landing_que_incluye_1920x1080.png" alt="Qué incluye el pack" className="w-full h-auto" data-id="element-477" />
        </motion.div>

        {/* Additional content list matching the image */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-16 max-w-4xl mx-auto" data-id="element-478">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-479">
            {items.map((item, index) => <div key={index} className="flex items-start gap-4 bg-gradient-to-br from-[#1a1a1a] to-black p-6 rounded-xl border border-[#C9A961]/20" data-id="element-480">
                <CheckCircle className="w-6 h-6 text-[#C9A961] flex-shrink-0 mt-1" data-id="element-481" />
                <p className="text-gray-300 text-lg" data-id="element-482">{item}</p>
              </div>)}
          </div>

          <div className="mt-12 text-center" data-id="element-483">
            <p className="text-gray-400 text-lg" data-id="element-484">
              Formato digital · Acceso inmediato
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}